























import * as Util from '@/util.ts';
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    hideX: {
      type: Boolean,
      default: false,
    },
    allowClose: {
      type: Boolean,
      default: true,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    onCloseCustomFunction: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isActive: this.$props.url ? this.$props.url === location.pathname : this.$props.value,
      isMobile: Util.mobileCheck(),
    };
  },
  methods: {
    onDimmerClick() {
      if (this.$props.allowClose) {
        if (this.$props.mini) {
          this.closeThis();
        } else {
          this.$router.go(-1);
        }
      }
    },
    onXClick() {
      if (this.$props.url) {
        if (this.$props.onCloseCustomFunction) {
          this.$props.onCloseCustomFunction();
        } else {
          this.$router.go(-1);
        }
      } else {
        this.closeThis();
      }
    },
    closeThis() {
      this.$data.isActive = false;
      this.$emit('input', this.$data.isActive);
      this.$store.commit('setModalVisible', false);
    },
    openThis() {
      this.$data.isActive = true;
      this.$emit('input', this.$data.isActive);
      Vue.nextTick(() => {
        (this.$refs.scrollArea as any).scrollTop = 0;
      });
      setTimeout(() => {
        this.$store.commit('setModalVisible', true);
      }, 100); // Need a delay to allow the close modal events to finish.
    },
  },
  mounted() {
    Util.eventBus.$on('closeModals', () => {
      // Don't close url modals since that requires a url change.
      if (!this.$props.url) {
        this.closeThis();
      }
    });
  },
  computed: {
    isKioskMode(): boolean {
      return this.$store.state.isKioskMode;
    },
  },
  watch: {
    value(isActive) {
      if (isActive) {
        this.openThis();
      } else {
        this.closeThis();
      }
    },
    $route(to, from) {
      if (to.path.includes(this.$props.url)) {
        this.openThis();
      } else {
        this.closeThis();
      }
    },
  },
});
